import FilterRPTRestaurant from "../components/common/filter/report/FilterRPTRestaurant";
import FilterRPTTongHopVeXe from "../components/common/filter/report/FilterTonghopvexe";
import { ReportType } from "../types/report.type";

export const reports: { [key: string]: ReportType } = {
  restaurant: {
    title: "Quán ăn",
    Filter: FilterRPTRestaurant,
  },
  ticket: {
    title: "Vé xe",
    Filter: FilterRPTTongHopVeXe,
  },
  // fos_rptonghopvexe: {
  //   apiCode: "fos_rptonghopvexe",
  //   title: "Tổng hợp vé bán",
  //   Filter: FilterTonghopvexe,
  //   columns: [
  //     {
  //       name: "Nhà xe",
  //       width: "150px",
  //       selector: (row) => row.ten_nha_xe,
  //     },
  //     {
  //       name: "Tổng số",
  //       width: "120px",
  //       center: true,
  //       selector: (row) => row.t_so_luong,
  //     },
  //     {
  //       name: "Hoàn thành",
  //       width: "120px",
  //       center: true,
  //       selector: (row) => row.sl_used,
  //     },
  //     {
  //       name: "Đặt vé",
  //       width: "150px",
  //       center: true,
  //       selector: (row) => row.sl_pending,
  //     },
  //     {
  //       name: "Đã hủy",
  //       width: "130px",
  //       center: true,
  //       selector: (row) => row.sl_cancel,
  //     },
  //     {
  //       name: "Áp dụng mã",
  //       width: "120px",
  //       center: true,
  //       selector: (row) => row.sl_sd_pos,
  //     },
  //     {
  //       name: "Tiền vé",
  //       width: "120px",
  //       right: true,
  //       selector: (row) => row.tien_hang_nt,
  //       format: (row) => numeralCustom(row.tien_hang_nt).format(),
  //     },
  //     {
  //       name: "Tiền CK",
  //       width: "120px",
  //       right: true,
  //       selector: (row) => row.tien_ck_nt,
  //       format: (row) => numeralCustom(row.tien_ck_nt).format(),
  //     },
  //     {
  //       name: "Tổng tiền",
  //       width: "120px",
  //       right: true,
  //       selector: (row) => row.tien_tt_nt,
  //       format: (row) => numeralCustom(row.tien_tt_nt).format(),
  //     },
  //     {
  //       name: "Nhà xe thu",
  //       width: "120px",
  //       right: true,
  //       selector: (row) => row.tien_nha_xe,
  //       format: (row) => numeralCustom(row.tien_nha_xe).format(),
  //     },
  //     {
  //       name: "Hoa hồng",
  //       width: "130px",
  //       right: true,
  //       selector: (row) => row.tien_hh,
  //       format: (row) => numeralCustom(row.tien_hh).format(),
  //     },
  //     {
  //       name: "Trả lại nhà xe",
  //       width: "130px",
  //       right: true,
  //       selector: (row) => row.tien_tt_hang,
  //       format: (row) => numeralCustom(row.tien_tt_hang).format(),
  //     },
  //   ],
  // },
  // fos_rpctvexe: {
  //   apiCode: "fos_rpctvexe",
  //   title: "Chi tiết vé bán",
  //   Filter: FilterChitietvexe,
  //   columns: [
  //     {
  //       name: "Trạng thái",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.ten_trang_thai,
  //       cell: (row) => {
  //         return (
  //           <Typography
  //             data-tag="allowRowEvents"
  //             sx={{
  //               fontWeight: 500,
  //               color: row.color,
  //             }}
  //           >
  //             {row.ten_trang_thai}
  //           </Typography>
  //         );
  //       },
  //     },
  //     {
  //       name: "Mã đặt chỗ",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.ma,
  //     },
  //     {
  //       name: "Xe khách",
  //       width: "150px",
  //       wrap: true,
  //       selector: (row) => {
  //         return !!row.xe
  //           ? `${row?.ten_nha_xe}${row?.bien_so ? ` (${row?.bien_so})` : ""}`
  //           : "";
  //       },
  //     },
  //     {
  //       name: "Ngày đi",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.tg_khoi_hanh,
  //       format: (row) => formatDateDisplay(row.tg_khoi_hanh, "DD/MM/YYYY"),
  //     },
  //     {
  //       name: "Giờ đi",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.tg_khoi_hanh,
  //       format: (row) => formatDateDisplay(row.tg_khoi_hanh, "HH:mm"),
  //     },
  //     {
  //       name: "Tên khách",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.ten_kh,
  //     },
  //     {
  //       name: "Ghế",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.ma_ghe,
  //     },
  //     {
  //       name: "Tiền vé",
  //       width: "120px",
  //       wrap: true,
  //       selector: (row) => row.tien_tt_nt,
  //       format: (row) => numeralCustom(row.tien_tt_nt).format(),
  //     },
  //   ],
  // },
};
